import { render } from "./GDPChart.vue?vue&type=template&id=7eed4dd6&scoped=true"
import script from "./GDPChart.vue?vue&type=script&lang=js"
export * from "./GDPChart.vue?vue&type=script&lang=js"

import "./GDPChart.vue?vue&type=style&index=0&id=7eed4dd6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eed4dd6"]])

export default __exports__